import store from "../reducers/configureStore";

export default function requirementStatus(permCode) {
    let requirements = (store.store.getState().auth as any).requirements;
    return requirements[permCode];
}
